// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13J38","colBig":"styles_colBig__31usG","colSmall":"styles_colSmall__34IzD","shopifyNameWrapper":"styles_shopifyNameWrapper__pr2MS"};